import {
  prisma,
  type Prisma,
  EventCategoryTranslations,
  ResourceType,
  ActionType,
} from "client";

// READ
export const getEventCategories = async (
  userId: string,
  languageId?: string
) => {
  try {
    const eventCategories = await prisma.eventCategory.findMany({
      include: {
        translations: true,
      },
    });

    return eventCategories;
  } catch (error: any) {
    return error;
  }
};

export const getEventCategory = async (
  userId: string,
  id: string,
  languageId?: string
) => {
  try {
    const eventCategory = await prisma.eventCategory.findUnique({
      where: { id },
      include: {
        translations: languageId
          ? {
              where: {
                languageId: languageId,
              },
            }
          : true,
      },
    });

    return eventCategory;
  } catch (error: any) {
    return error;
  }
};

// CREATE
export const createEventCategory = async (
  userId: string,
  eventCategoryPayload: Prisma.EventCategoryCreateInput,
  translitions: EventCategoryTranslations[]
) => {
  try {
    const eventCategory = await prisma.eventCategory.create({
      data: {
        ...eventCategoryPayload,
        translations: {
          createMany: {
            data: translitions,
          },
        },
      },
    });

    return eventCategory;
  } catch (error: any) {
    return error;
  }
};

// UPDATE
export const updateEventCategory = async (
  userId: string,
  id: string,
  eventCategoryPayload: Prisma.EventCategoryUpdateInput
) => {
  try {
    const eventCategory = await prisma.eventCategory.update({
      where: { id },
      data: eventCategoryPayload,
    });

    return eventCategory;
  } catch (error: any) {
    return error;
  }
};

// DELETE
export const deleteEventCategory = async (userId: string, id: string) => {
  try {
    const eventCategory = await prisma.eventCategory.delete({
      where: { id },
    });

    return eventCategory;
  } catch (error: any) {
    return error;
  }
};
